import {
  ContentfulMediaMentions,
  getContentfulMediaMentions,
} from 'api/contentful/getContentfulMediaMention'
import { SimpleFlowSignup } from 'components/simpleFlowSignup/SimpleFlowSignup'
import { GetStaticProps } from 'next'
import { useEffect } from 'react'
import { ANALYTICS, fireEvent, mutateAnalyticsData } from 'utils/analytics'
import { REVALIDATE_SECS } from 'utils/constants'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export interface IFormPayload {
  email: string
  password: string
  code: string
  is_promocode: boolean
}

interface Props {
  mediaMentions: ContentfulMediaMentions
}

export default function Page(props: Props) {
  useEffect(() => {
    mutateAnalyticsData({ flow: 'signup' })
    if (!ANALYTICS.type || ANALYTICS.type === 'unknown') {
      mutateAnalyticsData({ type: 'regular' })
    }
    fireEvent('signup_open')
  }, [])

  return <SimpleFlowSignup mediaMentions={props.mediaMentions} />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const mediaMentions = await getContentfulMediaMentions('global')
  if (!mediaMentions) throw Error('Could not fetch Media Mentions.')

  return {
    props: { ...(await getIntlProps(ctx, ['entrance', 'pricing_plan', 'auth'])), mediaMentions },
    revalidate: REVALIDATE_SECS,
  }
}
